import { gsap } from 'gsap'
import { fades } from 'settings/fades'

export function enableFade(container) {
  let state = true

  function toFade(value, cb) {

    if (state != value) {
      const { duration } = fades[+value]
      state = value
      const alpha = value ? 1 : 0
      const easing =  value ? 'sine.in' : 'sine.out'
      if(gsap.isTweening(container)) {
        return
      }
      const tween = gsap.to(container, {
        alpha: alpha,
        duration: duration,
        ease: easing,
        onComplete: () => {
          tween.kill()
          cb()
        },
      })
      tween.play()

    }

  }

  return toFade
}
